export const IMPACT_LEVELS = {
  1: {
    label: 'Minimal Impact',
    description: 'Basic task or experience with limited career growth potential'
  },
  2: {
    label: 'Minor Impact',
    description: 'Small but positive contribution to career development'
  },
  3: {
    label: 'Moderate Impact',
    description: 'Notable milestone or achievement in career progression'
  },
  4: {
    label: 'Significant Impact',
    description: 'Major career advancement or achievement'
  },
  5: {
    label: 'Major Impact',
    description: 'Career-defining moment or transformative achievement'
  }
} as const;

export const ENGAGEMENT_LEVELS = {
  1: {
    label: 'Draining',
    description: 'Found this deeply unfulfilling or frustrating'
  },
  2: {
    label: 'Disengaging',
    description: 'Would prefer to avoid similar experiences'
  },
  3: {
    label: 'Neutral',
    description: 'Neither particularly engaging nor disengaging'
  },
  4: {
    label: 'Engaging',
    description: 'Found this interesting and would like to do more'
  },
  5: {
    label: 'Energizing',
    description: 'Deeply passionate about this type of work/experience'
  }
} as const; 